if (!customElements.get('exercise-showcase')) {
  customElements.define(
    'exercise-showcase',
    class ExerciseShowcase extends HTMLElement {
      connectedCallback() {
        this.waitForSwiper();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.resizeObserver = null;
        this.main?.destroy(true, true);
        this.thumbs?.destroy(true, true);
        this.main = null;
        this.thumbs = null;
      }

      waitForSwiper() {
        if (window.Swiper) {
          this.init();
          return;
        }
        this.retries = (this.retries || 0) + 1;
        if (this.retries > 200) return;
        setTimeout(() => this.waitForSwiper(), 50);
      }

      init() {
        if (this.main) return;

        const mainEl = this.querySelector('.exercise-showcase__main');
        const thumbsEl = this.querySelector('.exercise-showcase__thumbs');
        if (!mainEl) return;

        this.thumbs = new Swiper(thumbsEl, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          watchSlidesProgress: true,
          freeMode: true,
        });

        this.main = new Swiper(mainEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          watchOverflow: true,
          navigation: {
            prevEl: this.querySelector('.exercise-showcase__nav--prev'),
            nextEl: this.querySelector('.exercise-showcase__nav--next'),
          },
          thumbs: {
            swiper: this.thumbs,
          },
          on: {
            afterInit: () => this.updateNavPosition(),
            slideChange: () => this.updateNavPosition(),
          },
        });

        this.resizeObserver = new ResizeObserver(() => this.updateNavPosition());
        this.resizeObserver.observe(mainEl);
        this.updateNavPosition();
      }

      updateNavPosition() {
        const stage = this.querySelector('.exercise-showcase__stage');
        const media = this.main?.slides?.[this.main.activeIndex]?.querySelector('.exercise-slide__media');
        if (!stage || !media) return;

        const stageRect = stage.getBoundingClientRect();
        const mediaRect = media.getBoundingClientRect();
        stage.style.setProperty('--es-nav-center', `${mediaRect.top - stageRect.top + mediaRect.height / 2}px`);
      }
    }
  );
}
